import { render, staticRenderFns } from "./sub-span.vue?vue&type=template&id=4823e7e0&scoped=true&"
import script from "./sub-span.vue?vue&type=script&lang=js&"
export * from "./sub-span.vue?vue&type=script&lang=js&"
import style0 from "./sub-span.vue?vue&type=style&index=0&id=4823e7e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4823e7e0",
  null
  
)

export default component.exports